module.exports = __webpack_public_path__ + "static/media/j2bd-white.c238adc1.svg";